import {UUID} from 'yougile-util'
import {PageService} from '../../extensions/page-service'
import {ComponentUpdater} from './index'

interface Opts {
  ignoreChat?: boolean
}

export const LocationUpdater: (opts?: Opts) => ComponentUpdater = opts => {
  let path: string
  const ignoreChat = opts && opts.ignoreChat
  return {
    displayName: `Location`,
    onMount(update: () => void): UUID {
      path = PageService.getPath()
      return PageService.addLocationListener(() => {
        const newPath = PageService.getPath()
        if (!ignoreChat || path !== newPath) {
          update()
        }
        path = newPath
      })
    },
    onUnmount(id: UUID): void {
      PageService.removeLocationListener(id)
    }
  }
}
